import { Navigate, Outlet } from "react-router-dom";

import { useUser } from "@/client/services/user";

export const EmailVerifiedGuard = () => {
  const { user, loading } = useUser();

  if (loading) return null;

  if (user && user?.emailVerified) {
    return <Outlet />;
  }

  return <Navigate to={`/dashboard/settings`} replace />;
};
